export default {
    reset_subuser_auth_title: "Restablecer la contraseña del subusuario",
    reset_subuser_auth_success_message: "La contraseña del usuario se ha restablecido correctamente",
    reset_subuser_auth_error_message: "La contraseña del usuario no se ha podido restablecer",
    reset_subuser_auth_message: "¿Desea restablecer la contraseña del usuario?",
    reset_subuser_auth_label: "Restablecer",
};